import { useEffect, useState } from "react";
import { useGeneralContext } from "../../General/Context";

import InterviewPreviewHeader from "./InterviewPreviewHeader";
import InterviewPreviewPage from "./InterviewPreviewPage";

import { InterviewService } from "../../../services/InterviewService";

export default function InterviewDetailsContent({ interviewId }) {
  const [interview, setInterview] = useState();

  useEffect(() => {
    if (interviewId) {
      InterviewService.getDetailsById(interviewId).then((data) => {
        setInterview(data);
        document.title = data.personalInformation.fullName;
      });
    }
  }, [interviewId]);
  const { userInformation } = useGeneralContext();

  return interview ? (
    <>
      <InterviewPreviewHeader
        interview={interview}
        userInformation={userInformation}
      ></InterviewPreviewHeader>

      <InterviewPreviewPage
        id={interviewId}
        interview={interview}
        setInterview={setInterview}
      />
    </>
  ) : (
    <></>
  );
}
